import { render, staticRenderFns } from "./StatementOfAccounts.vue?vue&type=template&id=5836117a&scoped=true&"
import script from "./StatementOfAccounts.vue?vue&type=script&lang=js&"
export * from "./StatementOfAccounts.vue?vue&type=script&lang=js&"
import style0 from "./StatementOfAccounts.vue?vue&type=style&index=0&id=5836117a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5836117a",
  null
  
)

export default component.exports